import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { IProductCategory } from "../../stateManagement/initial-states/product-category.initial-state";
import {
  IProductCategoryState,
  setMainProductCategory,
} from "../../stateManagement/reducers/productCategoryReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import AnimateButton from "../@extended/AnimateButton";

interface IProps {
  setIsSubCategoryNavOpen: (isOpen: boolean) => void;
  setPreviewedCategory: (category: IProductCategory) => void;
  previewedCategory: IProductCategory;
  isSubCategoryNavOpen: boolean;
}

const ProductCategoryNav = ({
  setIsSubCategoryNavOpen,
  setPreviewedCategory: setSubCategories,
  previewedCategory,
  isSubCategoryNavOpen,
}: IProps) => {
  const { categories, mainCategory } = useSelector<
    IRootReducerT,
    IProductCategoryState
  >((state) => state.productCategory);

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const dispatch = useDispatch<any>();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100% !important",
        overflowX: "auto !important",
        flexWrap: "nowrap",
        backgroundColor: "#F5F0E6",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={idGreaterThanMd ? 2 : 1}
        id="product-category-nav"
        sx={{
          py: "1rem",
          px: "1rem",
          position: "relative",
          marginLeft: "auto !important",
          marginRight: "auto !important",
          display: { xs: "flex", md: "flex", lg: "flex" },
          backgroundColor: "#F5F0E6",
        }}
      >
        {categories.map((category: IProductCategory, index: number) => {
          const isMainCategory = category.name === mainCategory?.name;

          const isPreviewedCategory =
            category.name === previewedCategory?.name && isSubCategoryNavOpen;

          return (
            <AnimateButton>
              <Typography
                key={index}
                variant="body1"
                sx={{
                  cursor: "pointer",
                  transition: "all .25s 0s ease-out",
                  borderRadius: "1.75rem",
                  p: ".5rem",
                  px: "1rem",
                  fontSize: "1rem",
                  textWrap: "nowrap",
                  fontWeight: "400",
                  fontFamily: "Inter",
                }}
                className={`hover:bg-[#2F5042] hover:text-white ${
                  isMainCategory
                    ? "bg-[#B89968] text-white"
                    : isPreviewedCategory
                      ? "bg-[#2F5042] text-white"
                      : ""
                }`}
                onMouseEnter={() => {
                  setSubCategories(category);
                  setIsSubCategoryNavOpen(true);
                }}
                onClick={() => {
                  if (!isMainCategory) {
                    dispatch(
                      setMainProductCategory({ category, subCategoryIndex: 0 }),
                    );
                  }
                  setIsSubCategoryNavOpen(true);
                }}
              >
                {category.name}
              </Typography>
            </AnimateButton>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default ProductCategoryNav;
